import React, { useEffect, useState } from 'react'
import { FiArrowRight, FiChevronDown, FiExternalLink, FiMenu, FiMonitor, FiMoon, FiMoreVertical, FiPaperclip, FiSend, FiSmartphone, FiSmile, FiSun, FiTablet, FiX } from "react-icons/fi"
import { motion } from "framer-motion"
import clx from 'classnames'
import { MSNBalloon } from '../components/shared/conversations/msn'
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { Waveform } from '../components/shared/wavesurfer'
import { WaveformNeon } from '../components/chat/neon/content/conversations'
import { useGeneral } from '../stores/useGeneral'

export const Index = () => {

    useEffect(()=>{
       document.body.style.background = '#171a1d'
       document.body.style.color = 'white'
    },[])

    return (
        <React.Fragment>
            <Bar />
            <Header />
            <HeroSection />
            <Legendary />
            <Demos />
            <LivePreview />
            <Features />
            <EmojiView />
            <MobileView />
            <SupportDemo />
            <Screenshoots />
            <LiveChatBox />
        </React.Fragment>
    )
}
 
const Bar = () => {
    return (
        <div className='sm:flex gap-2 items-center justify-center p-3 bg-blue-800'>
            <p className='p-1 px-2 bg-blue-700 rounded-md text-sm w-max'>NEW</p>
            <p>
            We have launched wide-variety & rich componets and many alternatives for using with multi-purposes. 
            </p>
            <p className='flex items-center gap-2 text-blue-500 cursor-pointer'> Check it now <i data-feather="arrow-right" className="h-4"> </i></p>
        </div>
    )
}

const Header = () => {
    return (
        <header className="flex justify-between items-center p-4 sm:p-10">
        <div>

            <a href="#" className="font-bold text-3xl">
                <img src="/images/demo/hype5-2.svg" className=" 
             h-8 sm:h-10 " />
            </a>
        </div>
        <div>
            <ul className="hidden xs:flex gap-10">
                <li className="relative group">
                    <a href="#" className="flex gap-1 items-center text-lg"> 
                        <p>Explore</p> <FiChevronDown size={23} className="h-4" /> 
                    </a>
                    <div className="hidden group-hover:grid drodpown absolute left-0 top-0 pt-10">
                        <div className="grid grid-cols-2 items-start w-max text-lg h-auto z-30 bg-zinc-800 rounded-md ">
                            <div className="grid m-3">
                                <a href="signin" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Signin</p></a>
                                <a href="signup" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Signup</p></a>
                                <a href="pick-avatar" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Pick Avatar</p></a>
                            </div>
                            <div className="grid m-3">
                                <a href="/chat/messenger" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Messenger</p></a>
                                <a href="/chat/neon" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Neon</p></a>
                                <a href="/chat/team" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Team</p></a>
                        </div>
                        </div>
                    </div>
                </li>
                <li><a href="#" className="flex gap-1 items-center text-lg"> <p>FAQ</p> </a></li>
                <li><a href="#" className="flex gap-1 items-center text-lg"> <p>Purchase</p> </a></li>
                <li><a href="#" className="flex gap-1 items-center text-lg"> <p>Release v1</p> </a></li>
            </ul>
        </div>
       <div className='flex gap-2 items-center'>
          <SelectLanguage />
            <img src="/images/demo/react.png" className="hidden sm:block w-10 h-10 cursor-pointer rounded-full" />
            <div className=''>

                <a href="/auth/signup" className={clx(
                    // `bg-transparent border border-white`,
                    `bg-blue-700 text-white hover:bg-blue-800`,
                    `p-3 sm:px-6 rounded-full`
                )}>Create Account</a>
                
            </div>
            <div className="hidden xs:block">
                <FiMenu size={23} />
            </div>
       </div>
    </header>
    )
}
const SelectLanguage = () => {
    const [selected, setSelected] = useState({code:'ar'})
    const [status, setStatus] = useState(false)

    return (
        <div className="hidden sm:flex gap-2 items-center z-[100]">
        <div className="relative" x-data="{lang:'en'}">
             <div
             onClick={()=>setStatus(!status)}
            >
                <div className="">
                    <img src={`/images/flags/${selected.code}.svg`} 
                    className="h-6 w-6 border-2 cursor-pointer bg-gray-300 object-cover rounded-full" />
                </div>
                <div
                className={clx(`dropdown absolute right-0 top-8 z-10 divide-y border dark:border-zinc-700 
                dark:border-zinc-900 bg-white dark:bg-zinc-800 rounded-lg w-40`,
                status == true ? 'block' :'hidden'
                )}
                 >
                    <ul className="py-2 text-sm text-gray-200">
                        {[
                            {language:'Arabic', code:'ar'},
                            {language:'Japan', code:'jp'},
                            {language:'Spanish', code:'es'},
                            {language:'English', code:'en'},
                        ].map(item=>(
                             <li
                             className="cursor-pointer"
                             onClick={()=>setSelected(item)}
                             >
                             <div
                                 className="flex gap-2 text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 p-2 flex gap-1 items-center"
                             >
                                 <img src={`/images/flags/${item.code}.svg`} className="h-6 w-6 cursor-pointer bg-gray-300 object-cover rounded-full border-none" />
                                 <p>{item.language}</p>
                             </div>
                             </li>
                        ))}
                    </ul>
               
                </div>
            </div>
        </div>
    </div>
    )
}

const HeroSection = () => {
    return(
        <div className="mb-20 sm:mb-32 mt-10 sm:mt-20 sm:px-20 relative ">
        <div className="absolute z-[25] sm:right-96 right-0 top-52 sm:-top-3 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
            <p className="text-4xl">👋</p> <p className="text-2xl font-semibold text-zinc-600">98K</p>
        </div>

        <div className="absolute z-[25] sm:right-44 -top-8 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
            <p className="text-4xl text-[crimson]">❤️</p> <p className="text-2xl font-semibold text-zinc-600">71K</p>
        </div>

        <div className="absolute z-[25] right-0 sm:right-52 sm:top-40 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
            <p className="text-4xl">😀</p> <p className="text-2xl font-semibold text-zinc-600">83K</p>
        </div>
        
        <div className=" items-center relative">
            <h1 className=" invisible left-0 right-0 top-0 text-7xl sm:text-9xl font-bold gradient-text">Hype5 Legendary React Chat Platform</h1>
            <h1 className=" absolute left-0 right-0 top-0 text-7xl sm:text-9xl font-bold gradient-text">Hype5 Legendary React Chat Platform</h1>
            <h1 className=" absolute left-0 right-0 blur-md top-0 text-7xl sm:text-9xl font-bold gradient-text">Hype5 Legendary React Chat Platform</h1>
        </div>

       <div className="flex gap-6 items-center ">
            <div className="linear inline-block p-5 sm:px-10 rounded-full mt-10 cursor-pointer flex items-center gap-3">
                <img src="/images/demo/android.png" className="h-8" />
                <div className="font-medium text-2xl">Android</div>
            </div>
            <div className="linear inline-block p-5 sm:px-10 rounded-full mt-10 cursor-pointer flex items-center gap-3">
                <img src="/images/demo/apple.png" className="h-8" />
                <div className="font-medium text-2xl">MacOS</div>
            </div>
            <div className="hidden flex items-center justify-center cursor-pointer hover:border-2 border-zinc-700 rounded-full w-14 h-14 mt-10 ">
                <i data-feather="arrow-down" className="h-8 w-8 animate-bounce text-zinc-400"></i>
            </div>
       </div>
    </div>

    )
}

const Legendary = () => {

    return(
        <div className="flex flex-col items-center justify-center">
        <div className="mb-14 text-center flex items-center flex-col">
            <img src="/images/demo/legendary.svg" className='h-20 mb-4' />
            <h3 className="text-4xl font-bold ">Experience the gorgeous and rich chat platform</h3>
            <p className="text-lg mt-4 text-gray-300 max-w-[700px]">
                Summer of the Mountain with number one! Clean and Aesthetic View of Chat App. Easily Customizable and friendly UI/UX.   
                Excellent view provides high impact because aesthetic is universal rule. Enjoy 😊 
            </p>
        </div>
        <img src="/images/demo/showcase.png" alt="" />
    </div>

    )
}

const Demos = () =>{
    return (
        <div className=" sm:grid md:grid-cols-2 lg:grid-cols-3 gap-10 sm:my-32 p-4 sm:px-5 xl:px-32 ">
      
        <div className="text-center relative">
            
            <a href="/chat/messenger" className="relative bg-[#fa4b8f] rounded-lg h-60 w-full p-2 flex items-center">
                <div className="absolute -top-4 -left-4 bg-pink-500 text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">1</div>
                <img src="/images/demo/view2.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 1</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Fully Responsible</h1>
            <p className="text-gray-400">Compatible with all devices and sizes. </p>
        </div>
        <div className="text-center relative">
            <a href="/chat/neon" className="relative bg-[#7c87f9] rounded-lg h-60 w-full p-2 flex items-center">
                <div className="absolute -top-4 -left-4 bg-[#7c87f9] text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">2</div>
                <img src="/images/demo/view4.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 2</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Light & Dark mode</h1>
            <p className="text-gray-400">Dark mode is good for eye health at night 
                All pages and components has darkmode styles. </p>
        </div>
        <div className="text-center relative">
            <a href="/chat/team" className="relative bg-[#7f39de] rounded-lg h-60 w-full p-2 flex items-center">
                <div className="absolute -top-4 -left-4 bg-[#c155d1] text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">3</div>
                <img src="/images/demo/view1.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 3</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Lifetime Free Updates</h1>
            <p className="text-gray-400">
                Future updates and empowerment to product is free. Pay once use all times to new releases.
            </p>
       </div>
       <div className="text-center relative">
            <a href="/chat/messenger/light" className="relative bg-[#fe90aa] rounded-lg h-60 w-full p-2 flex items-center">
                <img src="/images/demo/view5.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 1</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Rich Components</h1>
            <p className="text-gray-400">Up to date  features  coming  at frequent intervals
                and options are evolving. Make best.</p>
        </div>
        <div className="text-center relative">
            <a href="/chat/neon/light" className="relative bg-[#ffcbed] rounded-lg h-60 w-full p-2 flex items-center">
                <img src="/images/demo/view3.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 2</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Tailwind Support</h1>
            <p className="text-gray-400">
                Fast Produce because designing is more
                practical with Tailwind. 
            </p>
       </div>
        <div className="text-center relative">
            <a href="/chat/team/light" className="relative bg-[#c155d1] rounded-lg h-60 w-full p-2 flex items-center">
                <img src="/images/demo/view6.png" className="w-full h-full m-2 rounded-md object-cover" />
                <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 3</div>
            </a>
            <h1 className="text-2xl font-bold my-3">Well Documentation</h1>
            <p className="text-gray-400">Start to implement your site with 
                documentation that explain stages step by step. </p>
        </div>

    </div>
    )
}

const LivePreview = () => {
    const [tab, setTab] = useState('messenger')
    const [mode, setMode] = useState(true)
    const [viewport, setViewport] = useState('desktop')
  
   return (
        <div className="hidden md:block" >
            <div className="flex items-center justify-center my-6">
                <h2 className="text-5xl">Live Preview</h2>
            </div>
            <div className="absolute right-0 -top-20 " >
                <a>
                   <FiExternalLink size={23} />
                </a>
            </div>
            <div className="sm:flex items-center justify-between sm:mx-32">
                <div 
                 onClick={()=>setMode(!mode)}className="flex gap-2 items-center border border-2 border-zinc-700 animate-pulse rounded-full h-14 w-14 flex items-center justify-center cursor-pointer">
                    <p 
                    className="rounded-full  cursor-pointer " >
                        {!mode && <FiSun size={23} /> }
                        {mode && <FiMoon size={23} /> }
                    </p>

                </div>
            <div>

                <ul className="flex gap-3">
                    <li onClick={()=>setTab('team')}><div className={clx(tab=='team'?'border-gray-200':'border-gray-700', 'border-2 rounded-full p-2 px-6 cursor-pointer ')} >Team</div></li>
                    <li onClick={()=>setTab('messenger')}><div className={clx(tab=='messenger'?'border-gray-200':'border-gray-700', 'border-2 rounded-full p-2 px-6 cursor-pointer')} >Messenger</div></li>
                    <li onClick={()=>setTab('neon')}><div className={clx(tab=='neon'?'border-gray-200':'border-gray-700', 'border-2 rounded-full p-2 px-6 cursor-pointer ')} >Neon</div></li>
                    <li onClick={()=>setTab('support')}><div className={clx(tab=='support'?'border-gray-200':'border-gray-700', 'border-2 rounded-full p-2 px-6 cursor-pointer')} >Support</div>
                    </li>
                </ul>
                        
                <ul className="flex gap-3 my-3 items-center justify-center">
                    <li title="Desktop" onClick={()=>setViewport('desktop')} >
                        <div className={clx(viewport=='desktop'?'border-gray-500':'border-gray-800', `border-2 rounded-md p-2 px-4 cursor-pointer text-xs`)}>
                           <FiMonitor size={23} />
                        </div>
                    </li>
                    <li title="Tablet" onClick={()=>setViewport('tablet')}>
                        <div className={clx(viewport=='tablet'?'border-gray-500':'border-gray-800', `border-2 rounded-md p-2 px-4 cursor-pointer text-xs`)}>
                           <FiTablet size={23} />
                        </div>
                    </li>
                    <li title="Phone" onClick={()=>setViewport('phone')}>
                        <div className={clx(viewport=='phone'?'border-gray-500':'border-gray-800', `border-2 rounded-md p-2 px-4 cursor-pointer text-xs`)}>
                           <FiSmartphone size={23} />
                        </div>
                    </li>
                </ul>

                
            </div>


                <div className=" cursor-pointer sm:flex items-center gap-4" >
                    <a href={ `/chat/${tab}/${mode?'':'light'}` } className="border border-2 border-zinc-700 animate-pulse rounded-full h-14 w-14 flex items-center justify-center cursor-pointer" >
                         <FiExternalLink size={23} />
                    </a>
                </div>
            </div>

            <div className="sm:flex items-center justify-center relative sm:mx-32" >

                <iframe src={ `/chat/${tab}/${mode?'':'light'}`} frameborder="0"  // ${mode?'dark': 'light'}
                width={
                viewport=='desktop'?'100%':
                viewport=='tablet'?'70%':
                viewport=='phone'?'30%':''
                } height="600px" ></iframe>

            </div>    
        </div>
   )
}

const Features = () => {
    return (
        <React.Fragment>
                <div className="text-center justify-center grid gap-6 sm:gap-3 relative my-14 sm:my-32 overflow-hidden">
                    <div className="font-bold text-2xl sm:text-4xl">Climbing Success Mountain With a Helicopter!</div>

                    <div className="relative full">
                        <h1 className="invisible top-0 text-6xl sm:7xl font-bold gradient-text">SUCCESS OF MOUNTAIN!</h1>
                        <h1 className="absolute left-0 right-0 top-0 text-6xl sm:7xl font-bold gradient-text">SUCCESS OF MOUNTAIN!</h1>
                        <h1 className="absolute left-0 right-0 blur-md top-0 text-6xl sm:7xl font-bold gradient-text">SUCCESS OF MOUNTAIN!</h1>
                    </div>
                        
                    <p className="text-gray-200 sm:w-[800px] text-md sm:text-lg"> Implement your project the professional app that makes increase your growt and marketing performance. Happy Customers and Efficient Team Workers. </p>
                </div>
            

                
                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4 px-4 xs:px-10 md:mx-32">
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-xl overflow-hidden">
                            <img src="/images/demo/experience-1.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Fast Channels, Rooms </h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-xl overflow-hidden">
                            <img src="/images/demo/experience-2.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Group features</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-xl overflow-hidden">
                            <img src="/images/demo/experience-3.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Reactions</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-xl overflow-hidden">
                            <img src="/images/demo/experience-4.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Link Preview for <br/> Code & Files</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-xl overflow-hidden">
                            <img src="/images/demo/experience-5.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Realtime Interaction 
                            with People</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-32 w-full flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-6.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-base font-medium my-3">Channels and Rooms</h1>
                    </div>
                </div>


        </React.Fragment>
    )
}

const EmojiView = () =>{
    return (
        <div className="flex flex-col sm:flex-row gap-10 sm:gap-60 justify-center p-10 sm:p-0 mt-24">
            <div className="max-w-[400px]">
                <div className="font-bold text-4xl ">Easily Customizable Visual Feast</div>
                <p className="my-4">
                    Used last trend front-end technologies. Make simple 
                    your needs with additional tools. 
                </p>
                <ul className="my-4 grid gap-2">
                        <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Tailwind CSS</p>  </li>
                        <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Sass</p>  </li>
                        <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Alpine</p>  </li>
                    </ul>

                <a href="/chat/team">
                    <div className="bg-blue-600 hover:bg-blue-700 p-3 px-10 rounded-full w-max cursor-pointer font-medium">Try Demo</div>
                </a>
        </div>
            <div className="flex items-center justify-center relative">
                 <Picker data={data} onEmojiSelect={console.log} />
            </div>
        
        </div>
    )
}

const MobileView = () => {
    return (
        <React.Fragment>
            
            <div className="flex items-center justify-center text-center my-24 mb-14">
                <img src="/images/demo/leader.svg" className='h-24 mb-4 hidden' />
                <div className="hidden font-bold text-4xl mb-24">YOU MIGHT ASK</div>

                <div className="flex items-center flex-col w-full">

                <img src="/images/demo/leader.svg" className='h-14 mb-4' />

                    <img src="/images/demo/experience-9.png" className="mb-4 xs:h-32" />
                    
                    <div className="relative mb-4">
                        <h1 className=" invisible left-0 right-0 top-0 text-6xl sm:text-7xl font-bold gradient-text">BEST CHAT EXPERIENCE</h1>
                        <h1 className=" absolute left-0 right-0 top-0 text-6xl sm:text-7xl font-bold gradient-text">BEST CHAT EXPERIENCE</h1>
                        <h1 className=" absolute left-0 right-0 blur-md top-0 text-6xl sm:text-7xl font-bold gradient-text">BEST CHAT EXPERIENCE</h1>
                    </div>
                    <p className="text-gray-200 sm:w-[800px] text-lg text-center">
                        Included Trends like Stories & Reactions! Soon expect you new features like sound effects! Everything for a real-time socket connections.
                    </p> 
                </div>

            </div>


            <div className=" p-5 clear-both p-5 lg:px-32 overflow-hidden my-14 mb-24">
                <h3 className="hidden text-4xl font-medium lg:px-5">Responsive</h3>
            
            <ul className="flex gap-4 p-2 w-full  mover-mobile" >
                {[
                    'dark-1','light-1','dark-2','light-2','dark-3','light-3','dark-4','light-4','dark-5','light-5','dark-6','light-6',
                    'dark-7','light-7','dark-8','light-8','dark-9','light-9','dark-10','light-10','dark-11','light-11',
                    ].map(item=>(
                              <img src={`/images/demo/mobiles/${item}.png`} 
                        className="shadow-lg bg-white rounded-lg bg-center 
                        bg-contain bg-no-repeat w-52 rounded-xl"  />
                    ))}
            </ul>
            </div>
        </React.Fragment>

    )
}

const SupportDemo = () => {

    return (
        <React.Fragment>

                <div className="flex flex-col lg:flex-row gap-10 justify-center sm:p-8 lg:m-0">
                
                <div className="lg:h-[500px] sm:m-14 lg:m-0 rounded-md shadows bg-zinc-700 
                flex items-center rounded-xl overflow-hidden ">
                    <img src="/images/demo/support-blue.png" className="w-full h-full object-cover" />
                </div>

                <div className="lg:max-w-[400px] ml-14 lg:m-0">
                    <div className="font-bold text-4xl">Highly Customizable</div>
                        <p className="my-4 mb-8">
                            Multiple purpose of use.
                            There are have extra components for live chat box & support page with 
                            additional drawers / modals.
                        </p>
                    <a href="/chat/support/light" className="bg-blue-600 hover:bg-blue-700 p-3 px-10 
                    rounded-full w-max cursor-pointer font-medium">Try Demo</a>
                </div>

            </div>

            <WaveformNeon />
            <div id="waveform" className="py-14"></div>

            <div className="flex gap-10 flex-col lg:flex-row-reverse sm:p-8 lg:m-0 justify-center">
                <div className="lg:h-[500px] sm:m-14 lg:m-0 rounded-md shadows bg-zinc-700 flex items-center rounded-xl overflow-hidden ">
                    <img src="/images/demo/support-dark.png" className="w-full h-full object-cover" />
                </div>
                <div className="lg:max-w-[400px] ml-14 lg:m-0">
                    <div className="font-bold text-4xl">Diversity for different 
                        purposes</div>
                        <p className="my-4 mb-8">
                            We bring alternative components for most common
                            parts. You can prefer different styles.  Few options 
                            have at message box, chat input and sidebar 
                            and other many components. 
                        </p>
                    <a href="/chat/messenger" className="bg-blue-600 hover:bg-blue-700 p-3 px-10 rounded-full w-max cursor-pointer font-medium">Try Demo</a>
                </div>
            </div>
        </React.Fragment>
    )
}

const Screenshoots = () => {
    return (
        <React.Fragment>
                        
            <div className="sm:flex flex-col text-center items-center gap-4 justify-center mt-10 py-10">
                <div className="font-bold text-6xl">Start Quickly</div>
                <p className="text-lg">Your feedbacks are very important for us. Which features you wanna like to see?</p>
            </div>     

            <div className="flex items-center justify-center w-full mb-14 cursor-pointer">
                <a href="/chat/neon" className="bg-[#2dc08d] hover:bg-[#2dc08d]/80 px-16 p-5 rounded-md m-max text-white text-xl font-semibold"> 
                    BUY NOW  </a>
                </div>
            
                <div className="" id="">
                    <ul className="grid grid-cols-2 gap-2 sm:flex p-6 sm:p-0 sm:gap-8 items-center justify-center">
                        <li title="HTML Tailwind" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><div className="w-20 h-20 flex items-center justify-center"><img src="/images/frameworks/tailwind.png" className="w-20" /></div></li>
                        <li title="React" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><img src="/images/frameworks/react.png" className="w-20 h-20" />
                        </li>
                        <li title="Angular" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><img src="/images/frameworks/angular.png" className="w-20 h-20" />
                            <div className="absolute -top-4 -right-4 p-1 px-3 flex justify-center items-center bg-red-700 text-white rounded-md">Soon</div>
                        </li>
                        <li title="Vue" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><img src="/images/frameworks/vue.png" className="w-20 h-20" />
                            <div className="absolute -top-4 -right-4 p-1 px-3 flex justify-center items-center bg-red-700 text-white rounded-md">Soon</div>
                        </li>
                        <li title="Laravel" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><img src="/images/frameworks/laravel-2.png" className="w-20 h-20" />
                            <div className="absolute -top-4 -right-4 p-1 px-3 flex justify-center items-center bg-red-700 text-white rounded-md">Soon</div>
                        </li>
                        <li title="Flutter" className="rounded-lg bg-zinc-800 hover:bg-zinc-700 p-6 relative cursor-pointer flex items-center justify-center"><img src="/images/frameworks/flutter.svg" className="w-20 h-20" />
                            <div className="absolute -top-4 -right-4 p-1 px-3 flex justify-center items-center bg-red-700 text-white rounded-md">Soon</div>
                        </li>
                    </ul>
                </div>  

                <div className="p-5 overflow-hidden ">
                
                    <h3 className="hidden text-4xl font-medium  px-5">Live Samples</h3>

                    <ul className="flex gap-4 p-2 mover" >
                        {Array.from(Array(12)).map((sample,key)=>(
                             <li className="col-span-2">
                                <div 
                                style={{background:`url('/images/demo/support/dark-${key+1}.png')`, backgroundSize: 'contain' }}
                                className="w-[500px] h-[274px] shadow-lg bg-white rounded-lg bg-center bg-contain" />
                            </li>
                        ))}
                    </ul>

                    <ul className="flex gap-4 justify-end p-2 mover-reverse" >
                    {Array.from(Array(12)).map((sample,key)=>(
                             <li className="col-span-2">
                             <div 
                                style={{background:`url('/images/demo/support/light-${key+1}.png')`, backgroundSize: 'contain' }}
                                className="w-[500px] h-[274px] shadow-lg bg-white rounded-lg bg-center bg-contain" />
                         </li>
                        ))}
                       
                     </ul>

                    </div>

        </React.Fragment>
    )
}

const LiveChatBox = () => {
    const {darkmode, setMode} = useGeneral(state=>state);
    const [status, setStatus] = useState(false)
    const [color, setColor] = useState('blue')
    return (
        <React.Fragment>
                <div 
                onClick={()=>setStatus(!status)}
                className={clx(
                    'chat h-16 w-16 fixed right-10 bottom-10 bg-blue-700 --bg-[#513BFF] shadow-lg rounded-full z-[99] flex items-center justify-center p-1 cursor-pointer'
                )}>
                    <svg  viewBox="0 0 350 201" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <path d="M265.251 81.5417L200.292 182.691C238.927 184.6 317.472 188.417 322.568 188.417C327.662 188.417 286.479 117.167 265.251 81.5417Z" />
                        <path d="M142.311 136.167L110.042 187.116C129.235 188.077 168.254 190 170.785 190C173.316 190 152.857 154.111 142.311 136.167Z" />
                        <path d="M111.849 57.7917L0 168.996C32.0239 171.919 80.4104 179.282 94.92 180.328L149.625 89.6816L111.849 57.7917Z" />
                        <path d="M185.917 163.875L139.333 88.6327V80.9812L220.376 6.10352e-05L244.625 24.2306L185.917 163.875Z" />
                    </svg>
                </div>


                <div
                id="livechat"
                className={clx(color, `fixed flex flex-col justify-between bg-white shadow-xl border border-2-white dark:border-gray-700
                h-[30rem] w-full sm:w-[25rem] 
                overflow-hidden scrollbar bottom-24 right-0 sm:right-14 rounded-xl z-[999] scroll`,
                {'hidden':!status}
                )} 
                >
                    <div 
                    className="primary h-auto w-full backdrop-blur-md backdrop-opacity[90%] cursor-pointer p-2">
                    <img src="/images/livechat/light/pattern-14.svg" className="absolute bottom-0 h-20 w-full object-cover opacity-50" />
                    <div className=" flex justify-between items-center mt-2">
                            <div className="flex gap-2 cursor-pointer items-center">
                                <i data-feather="chevron-left"></i>
                                <div className="h-12 w-12 rounded-full bg-white border-2"></div>
                                <div>
                                    <div className="text-xl font-semibold">Need help?</div>
                                    <div className="flex items-center gap-1">
                                        <div className="h-3 w-3 rounded-full bg-green-400 border-2"></div>
                                        <p className="text-sm text-gray-100">We reply immediately</p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-1">
                                <div className="relative flex gap-2">
                                    <div onClick={()=>setMode(darkmode=='dark'?'light':'dark')}>
                                       {darkmode=='dark' &&  <FiMoon size={23} />}
                                       {darkmode!='dark' &&  <FiSun size={23} />}
                                    </div>
                                    <div > <FiMoreVertical size={23} /> </div>
                                    <div x-show="status" className="dropdown absolute right-0 top-6 bg-gray-50 shadow-md rounded-lg p-2">
                                        <ul className="flex gap-1">
                                            <li onClick={()=>setColor('green')}><div className="h-6 w-6 cursor-pointer rounded-full bg-green-400"></div></li>
                                            <li onClick={()=>setColor('blue')}><div className="h-6 w-6 cursor-pointer rounded-full bg-blue-500"></div></li>
                                            <li onClick={()=>setColor('yellow')}><div className="h-6 w-6 cursor-pointer rounded-full bg-yellow-400"></div></li>
                                            <li onClick={()=>setColor('purple')}><div className="h-6 w-6 cursor-pointer rounded-full bg-purple-500"></div></li>
                                        </ul>
                                    </div>
                                </div>
                                <FiChevronDown size={23} className='hidden' />
                                <FiX size={23} className='hidden' />
                            </div>
                    </div>

                    

                    </div>
                    <div className="bg-gray-50 dark:bg-zinc-800 h-full w-full overflow-y-auto">

                        <ul className="w-full">

                            <li>
                                <div className="grid grid-cols-12 items-end gap-2 m-4">
                                    <div className="dark:bg-zinc-700 h-8 w-8 col-span-1 bg-gray-300 cursor-pointer rounded-full"></div>
                                    <div className="dark:bg-zinc-700 dark:text-zinc-300 p-2 col-span-11 ml-2 bg-gray-200 text-sm text-black rounded-md">Welcome to our store! Whether you have a spesific question or need assistance, we're here for you. What would you like to know?</div>
                                </div>
                            </li>
                            <li>
                                <div className="flex justify-end m-4 relative overflow-hidden rounded-full">
                                    <p className="p-2 col-span-11 ml-2 px-4 cursor-pointer primary rounded-full text-black text-gray-50 ">
                                        <img src="/images/livechat/light/pattern-14.svg" className="absolute bottom-0 h-10 w-full object-cover opacity-30" />
                                        
                                        Shopping guide!</p>
                                </div>
                            </li>
                            <li>
                                <div className="grid grid-cols-12 items-end gap-2 m-4">
                                    <div className="dark:bg-zinc-700 h-8 w-8 col-span-1 bg-gray-300 cursor-pointer rounded-full"></div>
                                    <div className="dark:bg-zinc-700 dark:text-zinc-300 p-2 col-span-11 ml-2 bg-gray-200 text-sm text-black rounded-md"> Don't spend hours searching for the right product. We'll help you find exactly what you need in no-time! Also, fell free to check our items on sale now.  </div>
                                </div>
                            </li>
                            <li>
                                <div className="flex justify-end m-4">
                                    <div className="flex gap-1">
                                        <p className="dark:text-white p-2 col-span-11 ml-2 px-4 cursor-pointer border border-2 primary_border rounded-full text-black text-sm">Ok</p>
                                        <p className="dark:text-white p-2 col-span-11 ml-2 px-4 cursor-pointer border border-2 primary_border rounded-full text-black text-sm">Thanks</p>
                                    </div>
                                </div>
                            </li>

                        </ul>

                    </div>
                    <div className="bg-gray-200 h-24 text-zinc-700 flex items-center dark:bg-zinc-900">
                        <div className="flex items-center gap-2 p-4 w-full" >
                            <FiPaperclip className="w-12 cursor-pointer" />
                            <FiSmile className="w-12 cursor-pointer" />
                            <div className="w-full">
                                <input type="text" className="bg-transparent outline-none border-none w-full" placeholder="Write a message" />
                            </div>
                            <div className="">
                                <div className="primary flex items-center rounded-full p-2 h-12 w-12 ">
                                  <FiSend size={23} className="stroke-white cursor-pointer" />
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            
        </React.Fragment>
    )
}



 const Index1 = () => {

    useEffect(()=>{
       document.body.style.background = '#171a1d'
       document.body.style.color = 'white'
    },[])

    return (
        <React.Fragment>
                <div className='flex gap-2 items-center justify-center p-3 bg-blue-800'>
                    <p className='p-1 px-2 bg-blue-700 rounded-md text-sm'>NEW</p>
                    <p>
                     We have launched wide-variety & rich componets and many alternatives for using with multi-purposes. 
                    </p>
                    <p className='flex items-center gap-2 text-blue-500 cursor-pointer'> Check it now<FiArrowRight /> </p>
                </div>
                <header className="flex justify-between items-center p-10">
                    <div>

                        <a href="#" className="font-bold text-3xl">
                            <img src="/images/demo/hype5-2.svg" className="h-10" />
                        </a>
                    </div>
                    <div>
                        <ul className="flex gap-10">
                            <li className="relative group">
                                <a href="#" className="flex gap-1 items-center text-lg"> 
                                    <p>Explore</p> <FiChevronDown size={23} className="h-4" /> 
                                </a>
                                <div className="hidden group-hover:grid drodpown absolute left-0 top-0 pt-10">
                                    <div className="grid grid-cols-2 items-start w-max text-lg h-auto z-30 bg-zinc-800 rounded-md ">
                                        <div className="grid m-3">
                                            <a href="signin" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Signin</p></a>
                                            <a href="signup" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Signup</p></a>
                                            <a href="pick-avatar" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Pick Avatar</p></a>
                                        </div>
                                        <div className="grid m-3">
                                            <a href="/chat/messenger" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Messenger</p></a>
                                            <a href="/chat/neon" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Neon</p></a>
                                            <a href="/chat/team" className="cursor-pointer py-2 px-3 hover:bg-zinc-900/50 rounded-md"><p>Team</p></a>
                                    </div>
                                    </div>
                                </div>
                            </li>
                            <li><a href="#" className="flex gap-1 items-center text-lg"> <p>FAQ</p> </a></li>
                            <li><a href="#" className="flex gap-1 items-center text-lg"> <p>Purchase</p> </a></li>
                            <li><a href="#" className="flex gap-1 items-center text-lg"> <p>Release v1</p> </a></li>
                        </ul>
                    </div>
                   <div className='flex items-center justify-center gap-2'>
                        <img src="/images/demo/react.png" className="h-10 w-10 cursor-pointer rounded-full" />

                        <a href="signup" className={clx(
                            `bg-blue-700 text-white hover:bg-blue-800`,
                            `p-3 px-6 rounded-full`
                        )}>Create Account</a>
                            
                   </div>
                </header>

                <div className="mb-32 mt-20 px-20 relative">
                    <div className="absolute right-96 -top-3 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
                        <p className="text-4xl">👋</p> <p className="text-2xl font-semibold text-zinc-600">98K</p>
                    </div>

                    <div className="absolute right-56 top-14 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
                        <p className="text-4xl text-red-500">❤️</p> <p className="text-2xl font-semibold text-zinc-600">71K</p>
                    </div>

                    <div className="absolute right-52 top-64 p-1 pl-1 pr-4 rounded-full bg-gray-50 cursor-pointer flex items-center justify-center">
                        <p className="text-4xl">😀</p> <p className="text-2xl font-semibold text-zinc-600">83K</p>
                    </div>

                        
                    <motion.div
                        transition={{ ease: "easeOut", duration: 2 }}
                    >
                        <h1 className="text-9xl font-bold gradient-text relative">Hype5 Legendary React Chat Platform</h1>
                    </motion.div>


                    <div className="flex gap-6">
                        <div className="linear inline-block p-5 px-10 rounded-full mt-10 cursor-pointer flex items-center gap-3">
                            <img src="/images/demo/android.png" className="h-8" />
                            <div className="font-medium text-2xl">Android</div>
                        </div>
                        <div className="linear inline-block p-5 px-10 rounded-full mt-10 cursor-pointer flex items-center gap-3">
                            <img src="/images/demo/apple.png" className="h-8" />
                            <div className="font-medium text-2xl">MacOS</div>
                            
                        </div>
                </div>
                </div>





                <div className="flex flex-col items-center justify-center">
                    <div className="mb-14 text-center flex items-center flex-col">
                        <img src="/images/demo/leader.svg" className='h-20 mb-4' />
                        <h3 className="text-4xl font-bold ">Experience the gorgeous and rich chat platform</h3>
                        <p className="text-lg mt-4 text-gray-300 max-w-[700px]">
                            Summer of the Mountain with number one! Clean and Aesthetic View of Chat App. Easily Customizable and friendly UI/UX.   
                            Excellent view provides high impact because aesthetic is universal rule. Enjoy 😊 
                        </p>
                    </div>
                    <img src="/images/demo/showcase.png" alt="" />
                </div>


                <div className="grid grid-cols-3 gap-10 my-32 px-32">
                
                    <div className="text-center relative">
                        
                        <a href="chat/messenger" className="relative bg-[#fa4b8f] rounded-lg h-60 w-full p-2 flex items-center">
                            <div className="absolute -top-4 -left-4 bg-pink-500 text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">1</div>
                            <img src="/images/demo/view2.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 1</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Fully Responsible</h1>
                        <p className="text-gray-400">Compatible with all devices and sizes. </p>
                    </div>
                    <div className="text-center relative">
                        <a href="/chat/team" className="relative bg-[#7c87f9] rounded-lg h-60 w-full p-2 flex items-center">
                            <div className="absolute -top-4 -left-4 bg-[#7c87f9] text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">2</div>
                            <img src="/images/demo/view4.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 2</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Light & Dark mode</h1>
                        <p className="text-gray-400">Dark mode is good for eye health at night 
                            All pages and components has darkmode styles. </p>
                    </div>
                    <div className="text-center relative">
                        <a href="/chat/neon" className="relative bg-[#7f39de] rounded-lg h-60 w-full p-2 flex items-center">
                            <div className="absolute -top-4 -left-4 bg-[#c155d1] text-white p-2 w-14 h-14 rounded-full border-4 border-white flex items-center justify-center font-bold text-xl cursor-pointer">3</div>
                            <img src="/images/demo/view1.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-black/50 text-white p-2 px-6 rounded-full">Chat 3</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Lifetime Free Updates</h1>
                        <p className="text-gray-400">
                            Future updates and empowerment to product is free. Pay once use all times to new releases.
                        </p>
                </div>
                <div className="text-center relative">
                        <a href="messenger-light" className="relative bg-[#fe90aa] rounded-lg h-60 w-full p-2 flex items-center">
                            <img src="/images/demo/view5.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 1</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Rich Components</h1>
                        <p className="text-gray-400">Up to date  features  coming  at frequent intervals
                            and options are evolving. Make best.</p>
                    </div>
                    <div className="text-center relative">
                        <a href="neon-light" className="relative bg-[#ffcbed] rounded-lg h-60 w-full p-2 flex items-center">
                            <img src="/images/demo/view3.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 2</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Tailwind Support</h1>
                        <p className="text-gray-400">
                            Fast Produce because designing is more
                            practical with Tailwind. 
                        </p>
                </div>
                    <div className="text-center relative">
                        <a href="team-light" className="relative bg-[#c155d1] rounded-lg h-60 w-full p-2 flex items-center">
                            <img src="/images/demo/view6.png" className="w-full h-full m-2 rounded-md object-cover" />
                            <div className="absolute bottom-4 left-4 font-medium bg-white/80 font-medium text-gray-700 p-2 px-6 rounded-full">Chat 3</div>
                        </a>
                        <h1 className="text-2xl font-bold my-3">Well Documentation</h1>
                        <p className="text-gray-400">Start to implement your site with 
                            documentation that explain stages step by step. </p>
                    </div>

                </div>


                <div className="flex items-center flex-col mt-22 my-24 w-full">
                        <img src="/images/demo/legendary.svg" className='h-24 mb-4' />
                    <img src="/images/demo/experience-9.png" className="mb-4 h-32" />
                    <div className="text-center relative justify-center grid gap-3 flex w-full">
                        <div className="font-bold text-4xl mb-24">YOU MIGHT ASK</div>
                        <div className=" right-0 items-center">
                            <h1 className=" absolute left-0 right-0 top-14 text-7xl font-bold gradient-text">BEST CHAT EXPERIENCE</h1>
                            <h1 className=" absolute left-0 right-0 blur-md top-14 text-7xl font-bold gradient-text">BEST CHAT EXPERIENCE</h1>
                        </div>
                        <p className="text-gray-200 w-[800px] text-lg">
                            Included Trends like Stories & Reactions! Soon expect you new features like sound effects! Everything for a real-time socket connections.
                        </p>

                    </div>
                </div>
                
                <div className="grid grid-cols-3 gap-16 mx-32 mt-24 my-14">
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-1.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Fast Channels, Rooms </h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-2.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Group features</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-3.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Reactions</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-4.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Link Preview, Code & Files</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-5.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Realtime Interaction
                            with People</h1>
                    </div>
                    <div className="text-center">
                        <a href="#" className="bg-[#9af9cf] rounded-lg h-60 w-full p-2- flex items-center rounded-md overflow-hidden">
                            <img src="/images/demo/experience-6.png" className="w-full h-full object-cover" />
                        </a>
                        <h1 className="text-2xl font-bold my-3">Channels and Rooms</h1>
                    </div>
                </div>

                <div className="flex items-center justify-center w-full mb-24 cursor-pointer">
                    <a href="/chat/" className="bg-[#2dc08d] hover:bg-[#2dc08d]/80 px-16 p-5 rounded-md m-max text-white text-xl font-semibold">START NOW</a>
                </div>
                


                <div className="text-center justify-center grid gap-3 mt-22 my-24 mt-32">
                    <div className="font-bold text-3xl">Climbing Success Mountain With a Helicopter!</div>
                    <h1 className="text-7xl font-bold gradient-text">SUCCESS OF MOUNTAIN!</h1>
                    
                    <p className="text-gray-200 w-[800px] text-lg">
                        Implement your project the professional app that makes increase your growt and marketing performance. Happy Customers and Efficient Team Workers.
                    </p>
                </div>
             

        </React.Fragment>
    )
}

const OtherPart = () => {
    return (
        <React.Fragment>
                <div className="grid grid-cols-2 gap-10 py-10 mx-10">
                

                </div>


                <div className="flex gap-60 justify-center">
                    <div className="max-w-[400px]">
                        <div className="font-bold text-4xl ">Easily Customizable Visual Feast</div>
                        <p className="my-4">
                            Used last trend  front-end technologies. Make simple 
                            your needs with additional tools.  
                        </p>
                        <ul className="my-4 grid gap-2">
                                <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Tailwind CSS</p>  </li>
                                <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Sass</p>  </li>
                                <li className="flex gap-2 items-center"> <div className="rounded-full h-6 w-6 border-[#3758F9] border-4"></div> <p className="text-xl font-bold">Alpine</p>  </li>
                            </ul>

                        <div className="bg-blue-600 hover:bg-blue-700 p-3 px-10 rounded-full w-max cursor-pointer font-medium">Try Demo</div>
                </div>
                    <div className="flex items-center justify-center">
                        <div className="h-[400px] rounded-md bg-zinc-700 flex items-center p-4 w-full">
                            <img src="/images/demo/experience-7.png" className="w-full h-full object-cover" />
                        </div>
                    </div>
                
                </div>

                <div className="flex gap-60 justify-center">
                    <div className="mt-32 h-[500px] rounded-md bg-zinc-700 flex items-center p-4 ">
                        <img src="/images/demo/experience-8.png" className="w-full h-full object-cover" />
                    </div>
                    <div className="mt-32 max-w-[400px]">
                        <div className="font-bold text-4xl">Diversity for different 
                            purposes</div>
                            <p className="my-4 mb-8">
                                We bring alternative components for most common
                                parts. You can prefer different styles.  Few options 
                                have at message box, chat input and sidebar 
                                and other many components. 
                            </p>
                        <a href="/chat/support" className="bg-blue-600 hover:bg-blue-700 p-3 px-10 rounded-full w-max cursor-pointer font-medium">Try Demo</a>
                    </div>
                </div>




                <div className="flex flex-col items-center gap-4 justify-center mt-10 py-10">
                    <div className="font-bold text-6xl">Start Quickly</div>
                    <p className="text-lg">Your feedbacks are very important for us.</p>
            </div>     

            <div className="flex items-center justify-center w-full mb-24 cursor-pointer">
                <a href="/chat/neon" className="bg-[#2dc08d] hover:bg-[#2dc08d]/80 px-16 p-5 rounded-md m-max text-white text-xl font-semibold"> START NOW </a>
            </div>
            
        </React.Fragment>
    )
}

export const Balloon = () => {

    return (
        <React.Fragment>
            <MSNBalloon />
            <div className='h-24 w-24 fixed right-10 bottom-10 bg-[#513BFF] shadow-lg rounded-full z-[999] flex items-center justify-center p-1 cursor-pointer'>
                <svg  viewBox="0 0 350 201" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M265.251 81.5417L200.292 182.691C238.927 184.6 317.472 188.417 322.568 188.417C327.662 188.417 286.479 117.167 265.251 81.5417Z" />
                    <path d="M142.311 136.167L110.042 187.116C129.235 188.077 168.254 190 170.785 190C173.316 190 152.857 154.111 142.311 136.167Z" />
                    <path d="M111.849 57.7917L0 168.996C32.0239 171.919 80.4104 179.282 94.92 180.328L149.625 89.6816L111.849 57.7917Z" />
                    <path d="M185.917 163.875L139.333 88.6327V80.9812L220.376 6.10352e-05L244.625 24.2306L185.917 163.875Z" />
                </svg>
                {/** <img src="/images/demo/circle-blue.svg" className='w-20 h-full' /> */}
            </div>
        </React.Fragment>
    )
}
